<section class="content">
    <div class="card" style="padding:30px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                {{title}}
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-6 col-lg-3 col-md-3">
                <label style="font-size: 15px;">Enter Booth Code and Search <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                <input type="number" class="form-control" (keydown.enter)="getBusinessByProductOrder()"
                    id="booth_number"
                    style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;"
                    [(ngModel)]="selected_business_code">
            </div>
            <div class="col-sm-6 col-lg-2 col-md-2" style="margin-left: 12px; margin-top: 4%;">
                <button mat-raised-button color="primary" (click)="getBusinessByProductOrder()" class="button-class"
                    style="font-size: 20px; height: 40px;" [disabled]="selected_business_code == null">Search</button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!is_data_available">
        <div class="col">
            <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
            </mat-progress-spinner>
        </div>
    </div>
    <span *ngIf="by_product_order_list.length == 0 && enable_order_data && is_data_available">
        <label>There Is no Order Availble</label>
    </span>
    <span *ngIf="by_product_order_list.length != 0 && enable_order_data && is_data_available">
        <mat-card *ngFor="let order of by_product_order_list; let order_index=index" style="margin-bottom: 2%">
            <div class="row">
                <div class="col"><label>{{order['business_code']}} - {{order['agent_name']}}</label></div>
                <div class="col"><label>Ordered On : {{order['ordered_date'] | date}} Via
                        {{order['ordered_via']}}</label></div>
                <div class="col-2"><label>Total Price : {{order['total_cost'] | currency: 'INR'}}</label></div>
                <div class="col-3">
                    <button mat-button (click)="downloadGatePass(order['by_sale_group_id'], 'bill')"
                        *ngIf="order['sale_status_id'] == 2"
                        style="background: green;border-radius: 10px; font-size: 23px; color: white;">Bill</button>
                    <button mat-button (click)="downloadGatePass(order['by_sale_group_id'], 'dc')"
                        *ngIf="order['sale_status_id'] == 2 && order['business_type_id'] !== 14" 
                        style="background: green;border-radius: 10px; font-size: 23px; color: white; margin-left: 12%;">Dc</button>
                </div>
            </div><br>
            <table class="table table-bordered table-hovered">
                <thead>
                    <tr>
                        <th>S. No</th>
                        <th>Product Short Name</th>
                        <th>Count</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody *ngFor="let product of order['product_list']; let product_index=index">
                    <tr>
                        <td>{{product_index + 1}}</td>
                        <td>{{product['by_product_name']}}</td>
                        <td>{{product['count']}}</td>
                        <td>{{product['cost']}}</td>
                    </tr>
                </tbody>
            </table>
        </mat-card>
    </span>
</section>